import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'kodit-table-footer',
  templateUrl: './table-footer.component.html',
  styleUrls: ['./table-footer.component.scss'],
})
export class TableFooterComponent implements OnInit, OnChanges {
  @Input() items: any[];
  @Input() public totalCount: number;
  lenght: number;

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    this.lenght = this.totalCount ?? this.items?.length ?? 0;
  }
}
